import * as types from '../mutation-types'
import classService from '../../services/classes'

const state = {
    loading: false,
    errors: null,
    classes: [],
    myclasses: [], //for teachers,
    promoclasses:[] //for promotion purposes
}

const actions = {
    getAll({ commit }) {
        commit(types.CLASS_LOADING, true)
        classService.getAll().then(
            response => {

                commit(types.LOAD_CLASSES, response.data)
                commit(types.CLASS_LOADING, false)
                commit(types.CLASS_FAILURE, null)
            },
            error => {
                commit(types.CLASS_FAILURE, error)
                commit(types.CLASS_LOADING, false)
            }
        )
    },
    getMyClasses({ commit }) {
        commit(types.CLASS_LOADING, true)
        commit(types.CLASS_FAILURE, null)
        classService.myclasses().then(
            response => {

                commit(types.LOAD_MY_CLASSES, response.data)
                commit(types.CLASS_LOADING, false)

            },
            error => {
                commit(types.CLASS_FAILURE, error)
                commit(types.CLASS_LOADING, false)
            }
        )
    },
    getPromoClasses({ commit }) {
      commit(types.CLASS_LOADING, true)
      commit(types.CLASS_FAILURE, null)
      classService.promoclasses().then(
          response => {

              commit(types.LOAD_PROMOCLASSES, response.data)
              commit(types.CLASS_LOADING, false)

          },
          error => {
              commit(types.CLASS_FAILURE, error)
              commit(types.CLASS_LOADING, false)
          }
      )
  },
    add({ commit }, data) {
        commit(types.CLASS_LOADING, true)
        commit(types.CLASS_FAILURE, null)
        classService.add(data).then(
            response => {
                //console.log('responseooo', response)
                data.id = response.data.id
                data.teacher = response.data.teacher
                commit(types.ADD_CLASS, data)
                commit(types.CLASS_LOADING, false)
            },
            error => {
                commit(types.CLASS_FAILURE, error)
                commit(types.CLASS_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.CLASS_LOADING, true)
        commit(types.CLASS_FAILURE, null)
        classService.update(data.classroom)
            .then(
                response => {
                    //console.log("updated responsooooo", response)
                    data.classroom.teacher=response.data.teacher
                    commit(types.UPDATE_CLASS, data)
                    commit(types.CLASS_LOADING, false)
                },
                error => {
                    commit(types.CLASS_FAILURE, error)
                    commit(types.CLASS_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.CLASS_LOADING, true)
        commit(types.CLASS_FAILURE, null)
        classService.delete(data.classroom.id)
            .then(
                response => {

                    commit(types.DELETE_CLASS, data)
                    commit(types.CLASS_LOADING, false)
                },
                error => {
                    commit(types.CLASS_FAILURE, error)
                    commit(types.CLASS_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_CLASS](state, payload) {
        state.classes.unshift(payload);
    },
    [types.LOAD_CLASSES](state, payload) {
        state.classes = payload
    },
    [types.LOAD_MY_CLASSES](state, payload) {
        state.myclasses = payload
    },
    [types.LOAD_PROMOCLASSES](state, payload) {
      state.promoclasses = payload
  },
    [types.UPDATE_CLASS](state, payload) {
        Object.assign(state.classes[payload.index], payload.classroom);
    },
    [types.DELETE_CLASS](state, payload) {
        state.classes.splice(payload.index, 1)
    },
    [types.CLASS_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.CLASS_LOADING](state, payload) {
        state.loading = payload
    },
}

const getters = {
    CLASSES: state => {
        return state.classes
    },

    MYCLASSES: state => {
        return state.myclasses
    },

    PROMOCLASSES: state => {
      return state.promoclasses
    },

    CLASS_ERROR: state => {
        return state.errors
    },

    CLASS_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/classes.js